/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class LockConfigDetails {
    getFixupPrototypeFunction() { return LockConfigDetails.fixupPrototype; }

    static newInstance(model: Partial<LockConfigDetails>): LockConfigDetails {
        let obj = Object.assign(new LockConfigDetails(), model);
        LockConfigDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<LockConfigDetails>): LockConfigDetails {
        if (!model) return null;
        return LockConfigDetails.newInstance(<LockConfigDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: LockConfigDetails) {
        if (!obj) return;

        models.LockConfigDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: LockConfigDetails): boolean {
        Object.setPrototypeOf(obj, LockConfigDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.scope_details) {
            models.LockConfigScopeDetailsBase.fixupPrototype(this.scope_details);
        }
    }

    /**
     * Id of the Lock Configuration
     */
    id: string;

    /**
     * Scope of Lock
     */
    lock_scope: models.LockScope;

    /**
     * Lock Config Scope Details
     */
    scope_details: models.LockConfigScopeDetailsBase;

    /**
     * Cloud Provider to select
     */
    service_name: models.CloudServiceName;

    /**
     * Type of Lock
     */
    lock_type: models.LockType;

    /**
     * Status of Lock
     */
    status: models.LockStatus;

    /**
     * IDS of the tenants
     */
    tenant_ids: Array<string>;

    /**
     * Created at
     */
    created_at: Date;

    /**
     * Updated at
     */
    updated_at: Date;

    /**
     * Created by
     */
    created_by: string;

    /**
     * Updated by
     */
    updated_by: string;

}
